import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { emailTemplateEndpoints } from '@/lib/api/endpoints';
import { emailTemplateKeys } from '@/lib/queryKeys';
import type { EmailTemplateFull } from '@/types/emailTemplate';

/** Fetches one email template's full working copy (subject + HTML body). */
export function useEmailTemplate(id: string) {
  return useApiQuery<EmailTemplateFull>({
    queryKey: emailTemplateKeys.detail(id),
    queryFn: () => apiGet<EmailTemplateFull>(operationsClient, emailTemplateEndpoints.detail(id)),
    enabled: Boolean(id),
  });
}
